module.exports = __webpack_public_path__ + "img/20220519.66d662c5.png";